import { Injectable } from '@angular/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { GlobalMessageService, GlobalMessageType, UserIdService, WindowRef } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class MyActiveCartService extends ActiveCartService {
  constructor(
    multiCartFacade: MultiCartFacade,
    userIdService: UserIdService,
    private globalMessageService: GlobalMessageService,
    override winRef: WindowRef
  ) {
    super(multiCartFacade, userIdService, winRef);
  }

  override addEntry(productCode: string, quantity: number): void {
    super.addEntry(productCode, quantity);
    this.globalMessageService.add(`Adding ${productCode} to cart`, GlobalMessageType.MSG_TYPE_INFO);
  }

  override updateEntry(entryNumber: number, quantity: number) {
    super.updateEntry(entryNumber, quantity);
    this.globalMessageService.add('Cart was updated', GlobalMessageType.MSG_TYPE_INFO);
  }

  override removeEntry(entry: OrderEntry) {
    super.removeEntry(entry);
    this.globalMessageService.add('Entry deleted', GlobalMessageType.MSG_TYPE_ERROR);
  }
}
